import { render, staticRenderFns } from "./Wrapper.vue?vue&type=template&id=4d57c034&"
import script from "./Wrapper.vue?vue&type=script&lang=js&"
export * from "./Wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d57c034')) {
      api.createRecord('4d57c034', component.options)
    } else {
      api.reload('4d57c034', component.options)
    }
    module.hot.accept("./Wrapper.vue?vue&type=template&id=4d57c034&", function () {
      api.rerender('4d57c034', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/Wrapper.vue"
export default component.exports